'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'CountryRestService',
    function ($modal, CountryRestService) {

        return {
            edit: edit,
            create: create,
            api: CountryRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/country-modal-create.html'),
                controller: 'CountryModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    country: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/country-modal-create.html'),
                controller: 'CountryModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    country: function () {
                        return item;
                    }
                }
            });
        }

    }];